/** https://stackoverflow.com/a/21742107/5106072 */

export const getCustomDeviceDetails = (ua?: string) => {
  if (!ua) {
    return {
      isMobile: false,
      isTablet: false,
      platform: 'unknown',
    }
  }
  const details = {
    isMobile:
      /Android/i.test(ua) ||
      /webOS/i.test(ua) ||
      /iPhone/i.test(ua) ||
      /iPod/i.test(ua) ||
      /BlackBerry/i.test(ua) ||
      /Mobile/i.test(ua) ||
      /Windows Phone/i.test(ua),
    isTablet:
      /iPad/i.test(ua) ||
      (/Android/i.test(ua) && !/Mobile/i.test(ua)) ||
      /Tablet/i.test(ua) ||
      /Nexus 7|Nexus 10/i.test(ua) ||
      /KFAPWI|Kindle|Silk|PlayBook/i.test(ua),
    platform: 'unknown' as string,
  }

  if (/iPhone/i.test(ua)) details.platform = 'iPhone'
  else if (/iPad/i.test(ua)) details.platform = 'iPad'
  else if (/Android/i.test(ua)) details.platform = 'Android'

  return details
}

export function getIsMobileDevice(userAgent?: string) {
  if (!userAgent) {
    return false
  }
  const deviceDetails = getCustomDeviceDetails(userAgent)
  return deviceDetails.isMobile || deviceDetails.isTablet
}

export type MobileDevicePlatformType = 'Android' | 'iPhone' | 'iPad' | 'unknown'
